import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doDetailLiveTracking = createAsyncThunk("liveTracking/doDetailLiveTracking", async (token, thunkAPI) => {
  try {
    const { response, error } = await api.doDetailLiveTracking(token);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDetailLiveTrackingNoFetching = createAsyncThunk(
  "liveTracking/doDetailLiveTrackingNoFetching",
  async (token, thunkAPI) => {
    try {
      const { response, error } = await api.doDetailLiveTracking(token);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
